export const Marquee = () => {
  const words = ["Calm", "Peace", "Love", "Safety", "Connection", "Grounded"];
  return (
    <section data-testid="marquee-section" className="bg-ink py-8 md:py-10 overflow-hidden">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {words.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-display italic font-medium text-cream text-4xl md:text-6xl px-10">
                  {w}
                </span>
                <span className="h-2.5 w-2.5 rounded-full bg-rose" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
